document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.nav-select-block').forEach(block => {
		const categorySelect = block.querySelector('.nav-select-category')
		const optionSelect = block.querySelector('.nav-select-option')
		const dataScript = block.querySelector('.nav-select-data')

		if (!categorySelect || !optionSelect || !dataScript) return

		const categoriesData = JSON.parse(dataScript.textContent || '[]')

		function populateOptions(categoryIndex) {
			categoryIndex = parseInt(categoryIndex, 10)

			optionSelect.innerHTML = '<option value="">Select...</option>'
			optionSelect.disabled = true

			if (isNaN(categoryIndex)) return

			const category = categoriesData[categoryIndex]
			if (!category || !category.options) return

			category.options.forEach(option => {
				const optionElement = document.createElement('option')
				optionElement.value = option.url
				optionElement.textContent = option.label

				if (option.new_tab) {
					optionElement.setAttribute('data-new-tab', '1')
				}

				optionSelect.appendChild(optionElement)
			})

			optionSelect.disabled = false
		}

		categorySelect.addEventListener('change', e => {
			populateOptions(e.target.value)
		})

		optionSelect.addEventListener('change', e => {
			const url = e.target.value
			if (!url) return

			const selectedOption = optionSelect.options[optionSelect.selectedIndex]
			const openInNewTab = selectedOption.getAttribute('data-new-tab') === '1'

			// Reset selects
			categorySelect.value = ''
			optionSelect.innerHTML = '<option value="">Select...</option>'
			optionSelect.disabled = true

			// Navigate
			if (openInNewTab) {
				window.open(url, '_blank')
			} else {
				window.location.href = url
			}
		})
	})
})
